var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12","sm":"8"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-title',[_vm._v("За контакт с Артикет ЕООД:")]),_vm._v(" "),_c('v-card-text',[_c('p',[_vm._v("email: info@articket.eu")])])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }